import { EinkaufslistenEintrag, Liste, useAddListeMutation, useGetEinkaeufeQuery, useGetListeQuery, useListListenQuery, useRemoveListeMutation, useRemoveListenGerichtMutation, useRemoveZusaetzlichMutation, useSetIstEingekauftMutation, useSetIstNochDaMutation, useSetKommentarMutation, useSetZusaetzlichMutation } from "./listenConnector"
import "./ListenComponent.css";
import classNames from "classnames";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faInfoCircle, faTrash, faXmark } from "@fortawesome/free-solid-svg-icons";
import { GerichtHinzufuegenComponent } from "./GerichtHinzufuegenComponent";
import { MainContent } from "../../utils/MainContent";
import { Menge } from "../../utils/Menge";
import { Mengenangabe } from "../../utils/Mengenangabe";
import { AddZutatComponent } from "../gerichte/AddZutatComponent";
import { Tooltip, useTooltipProps } from "../../utils/Tooltip";
import { Link, Route, Switch, useLocation, useParams } from "wouter";
import { NavLink } from "../../NavLink";

const monate = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]

function FormattedDate(props: { rawDate: string }) {
    const date = new Date(props.rawDate);
    return <>{date.getDate().toString().padStart(2, "0")}. {monate[date.getMonth()]} {date.getFullYear()}</>
}

export function ListenListe() {
    const { data: listen } = useListListenQuery();
    const [addListe] = useAddListeMutation();

    return <>
        <ul>
            <li><button onClick={() => addListe()}>Neue Liste anlegen...</button></li>
            {listen?.map(({ datum, id }) => <li key={id}><NavLink to={`/listen/${id}/`}><FormattedDate rawDate={datum} /></NavLink></li>)}
        </ul>

        <MainContent backLink="/listen" >
            <Route path="/listen/:id/**">
                <ListenRouteComponent />
            </Route>
        </MainContent>
    </>
}
function ageInDays(liste: Liste) {
    return (Date.now() - new Date(liste.datum).getTime()) / (24 * 60 * 60 * 1000);
}
export function ListenRouteComponent() {
    const id = parseInt(useParams().id!);
    const { data } = useGetListeQuery(id);
    const [removeListe] = useRemoveListeMutation();
    const [, navigate] = useLocation();

    if (!data) return <>Loading...</>

    return <div className="einkaeufe">

        {ageInDays(data) < 10 &&
            <FontAwesomeIcon icon={faTrash} className="remove-button" onClick={() => {
                if (data.gerichte.length !== 0
                    && !window.confirm(`Sind sie sicher, dass sie diese Liste mit ${data.gerichte.length} Gerichten löschen wollen?`))
                    return;
                removeListe(id);
                navigate("/listen");
            }} />}


        <h2>Liste vom <FormattedDate rawDate={data.datum} /> (ID: {id})</h2>


        <nav>
            <NavLink to={`/listen/${id}/`}>Übersichtsmodus</NavLink>
            <NavLink to={`/listen/${id}/ist-noch-da`}>Nachschaumodus</NavLink>
            <NavLink to={`/listen/${id}/einkaufen`}>Einkaufsmodus</NavLink>
        </nav>

        <Switch>
            <Route path="/listen/:id/" component={ListenUebersichtsComponent} />
            <Route path="/listen/:id/ist-noch-da" component={ListenNachschauComponent} />
            <Route path="/listen/:id/einkaufen" component={ListenEinkaufComponent} />
        </Switch>
    </div>
}

function ListenUebersichtsComponent() {
    const id = parseInt(useParams().id!);
    const { data } = useGetListeQuery(id);
    const [removeListenGericht] = useRemoveListenGerichtMutation();
    const [setZusaetzlich] = useSetZusaetzlichMutation();

    if (!data) return <>Loading...</>

    const showDeleteButtons = ageInDays(data) < 10;

    return <>
        Gerichte:

        <ul>
            {data.gerichte.map(eintrag =>
                <li key={eintrag.id}>
                    {eintrag.menge}x
                    <Link to={`/gerichte/${eintrag.gericht.id}`}>
                        {eintrag.gericht.name}
                    </Link>

                    {showDeleteButtons &&
                        <FontAwesomeIcon icon={faXmark} className="remove-button" onClick={() => {
                            removeListenGericht({ listeId: id, gerichtId: eintrag.gericht.id });
                        }} />}
                </li>
            )}
        </ul>

        <GerichtHinzufuegenComponent listeId={id} />

        <div style={{ height: "2em" }} />

        Einkäufe:

        <Einkaeufe liste={id} />

        <AddZutatComponent onConfirm={(zutatId, menge) => setZusaetzlich({ listeId: id, zutatId, ...menge })} />
    </>
}

function Einkaeufe(props: { liste: number }) {
    const { data } = useGetEinkaeufeQuery(props.liste);
    if (!data) return <>Loading...</>

    return <table>
        <thead>
            <tr>
                <td style={{ width: "1.5em" }}></td>
                <td>Name</td>
                <td>Menge</td>
                <td className="list-header-rotated">Kategorie</td>
                <td className="list-header-rotated">Noch da?</td>
                <td className="list-header-rotated">Eingekauft?</td>
                <td>Kommentar</td>
            </tr>
        </thead>
        <tbody>
            {data.map((eintrag, i) => <UebersichtsEintrag key={i} listeId={props.liste} eintrag={eintrag} />)}
        </tbody>
    </table>
}

function EintragMenge(props: {
    menge: Mengenangabe[],
    zusaetzlicheMenge: Mengenangabe | null,
    zutatId: number,
    listeId: number,
    zusaetzlicheMengeIsRemovable?: boolean
}) {
    const { menge, zusaetzlicheMenge, listeId, zutatId, zusaetzlicheMengeIsRemovable } = props;
    const [removeZusaetzlich] = useRemoveZusaetzlichMutation();
    return <span className="eintrag-menge">
        {menge.map((x, i) => <Menge key={i} {...x} />)}
        {zusaetzlicheMenge &&
            <Menge {...zusaetzlicheMenge}
                className={classNames("menge-zusaetzlich", { "menge-zusaetzlich-removable": zusaetzlicheMengeIsRemovable })}
                onClick={zusaetzlicheMengeIsRemovable ? (() => removeZusaetzlich({ listeId, zutatId })) : undefined}
            />
        }
    </span>
}

function UebersichtsEintrag(props: { listeId: number, eintrag: EinkaufslistenEintrag }) {
    const { listeId, eintrag } = props;
    const [setIstNochDa] = useSetIstNochDaMutation();
    const [setIstEingekauft] = useSetIstEingekauftMutation();
    const [setKommentar] = useSetKommentarMutation();
    const [removeZusaetzlich] = useRemoveZusaetzlichMutation();
    const location = { listeId, zutatId: eintrag.zutatId };

    const { tooltipContainerProps, tooltipProps } = useTooltipProps();

    return <tr
        className={classNames({ done: eintrag.istNochDa || eintrag.istEingekauft })}
        {...tooltipContainerProps}
    >
        <Tooltip {...tooltipProps}>
            {eintrag.name}
            <EintragQuellen eintrag={eintrag} />
        </Tooltip>
        <td>{
            eintrag.zusaetzlicheMenge &&
            <FontAwesomeIcon
                icon={faXmark}
                className="checkmark"
                onClick={() => removeZusaetzlich({ listeId, zutatId: eintrag.zutatId })}
            />
        }</td>
        <td>{eintrag.name}</td>
        <td><EintragMenge {...eintrag} {...{ listeId }} zusaetzlicheMengeIsRemovable /></td>
        <td>{eintrag.kategorie}</td>
        <td>
            <FontAwesomeIcon
                icon={faCheck}
                className={classNames("checkmark", "ist-da", "yes", { active: eintrag.istNochDa === true })}
                onClick={() => setIstNochDa({ ...location, value: eintrag.istNochDa === true ? null : true })}
            />
            <FontAwesomeIcon
                icon={faXmark}
                className={classNames("checkmark", "ist-da", "no", { active: eintrag.istNochDa === false })}
                onClick={() => setIstNochDa({ ...location, value: eintrag.istNochDa === false ? null : false })}
            />
        </td>
        <td>
            <FontAwesomeIcon
                icon={faCheck}
                className={classNames("checkmark", "eingekauft", "yes", { active: eintrag.istEingekauft === true })}
                onClick={() => setIstEingekauft({ ...location, value: true })}
            />
            <FontAwesomeIcon
                icon={faXmark}
                className={classNames("checkmark", "eingekauft", "no", { active: eintrag.istEingekauft === false })}
                onClick={() => setIstEingekauft({ ...location, value: false })}
            />
        </td>
        <td
            contentEditable
            suppressContentEditableWarning
            onBlur={e => setKommentar({ ...location, value: e.currentTarget.innerText })}>
            {eintrag.kommentar}
        </td>
    </tr>
}

function ListenNachschauComponent() {
    const listeId = parseInt(useParams().id!);
    const { data } = useGetEinkaeufeQuery(listeId);

    if (!data) return <>Loading...</>

    return <ul className="liste-nachschauen">{data.map((eintrag, i) =>
        <ListenNachschauEintrag key={i} eintrag={eintrag} listeId={listeId} />
    )}</ul>
}

function ListenNachschauEintrag(props: { eintrag: EinkaufslistenEintrag, listeId: number }) {
    const [setIstNochDa] = useSetIstNochDaMutation();
    const { listeId, eintrag } = props;
    const location = { listeId, zutatId: eintrag.zutatId };
    const [showQuellen, setShowQuellen] = React.useState(false);

    return <li className={classNames({ done: eintrag.istNochDa })}>
        <FontAwesomeIcon
            icon={faCheck}
            className={classNames("checkmark", "ist-da", "yes", { active: eintrag.istNochDa === true })}
            onClick={() => setIstNochDa({ ...location, value: eintrag.istNochDa === true ? null : true })}
        />
        <FontAwesomeIcon
            icon={faXmark}
            className={classNames("checkmark", "ist-da", "no", { active: eintrag.istNochDa === false })}
            onClick={() => setIstNochDa({ ...location, value: eintrag.istNochDa === false ? null : false })}
        />
        &ensp;
        <EintragMenge {...eintrag} {...{ listeId }} />&nbsp;
        <span onClick={() => setShowQuellen(x => !x)}>
            {eintrag.name}
        </span>
        {showQuellen && <EintragQuellen eintrag={eintrag} />}
    </li>
}

function EintragQuellen(props: { eintrag: EinkaufslistenEintrag }) {
    const { eintrag } = props;
    return <div>
        Quellen:
        <ul>
            {eintrag.gerichte.map((quelle, i) =>
                quelle.anzahlGerichte > 1 ?
                    <li key={i}>{quelle.gerichtName}: {quelle.anzahlGerichte} × <Menge menge={quelle.mengeProGericht} einheit={quelle.einheit} /> = <Menge menge={quelle.mengeGesamt} einheit={quelle.einheit} /></li> :
                    <li key={i}>{quelle.gerichtName}: <Menge menge={quelle.mengeGesamt} einheit={quelle.einheit} /></li>
            )}
        </ul>
    </div>
}

function ListenEinkaufComponent() {
    const listeId = parseInt(useParams().id!);
    const { data } = useGetEinkaeufeQuery(listeId);
    if (!data) return <>Loading...</>

    return <div>
        Anklicken, um als eingekauft zu markieren.
        <ul className="liste-einkaufen">{data
            .filter(x => !x.istNochDa)
            .map((eintrag, i) => <ListenEinkaufEintrag key={i} eintrag={eintrag} listeId={listeId} />)
        }</ul>
    </div>
}

function ListenEinkaufEintrag(props: { eintrag: EinkaufslistenEintrag, listeId: number }) {
    const [setIstEingekauft] = useSetIstEingekauftMutation();
    const { eintrag, listeId } = props;
    const location = { listeId, zutatId: eintrag.zutatId };
    const [showQuellen, setShowQuellen] = React.useState(false);

    return <li className={classNames({ done: eintrag.istEingekauft })}>
        <FontAwesomeIcon className="eintrag-info-button" icon={faInfoCircle} onClick={() => setShowQuellen(x => !x)} />
        <div className="eintrag"
            onClick={() => setIstEingekauft({ ...location, value: !eintrag.istEingekauft })}>
            <EintragMenge {...eintrag} {...{ listeId }} /> {eintrag.name}
            {(eintrag.kommentar?.trim().length ?? 0) > 0 && <span className="kommentar"> ({eintrag.kommentar!.trim()})</span>}
        </div>
        {showQuellen && <EintragQuellen eintrag={eintrag} />}
    </li>
}
